import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { getCountries, getThemeVariables } from 'store/siteConfig'
import { recordCountlyEvent } from 'utils'
import _ from 'lodash'

// ------------------------------------
// Constants
// ------------------------------------
export const PAY_PAGE_RESULT = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    QUERY_FINISH: null,
    GET_BANNER_REQUEST: null,
    GET_BANNER_SUCCESS: null,
    DOWN_LOAD_REQUEST: null,
    DOWN_LOAD_SUCCESS: null
  },
  'PAY_PAGE_RESULT'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init(data, count) {
  return (dispatch, getState) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        errControl: true,
        endpoint: data.paymentOrderNo
          ? 'cashierii/pay/v1/unauth/query-result'
          : 'cashierii/order/v1/unauth/query-trade-result',
        requestAction: PAY_PAGE_RESULT.INIT_REQUEST,
        successAction: PAY_PAGE_RESULT.INIT_SUCCESS,
        success: function(result) {
          // If query-trade-result doesn't include paymentMethod (seen in some VISA installment flows),
          // and we have a paymentOrderNo, call query-result and merge its paymentMethod into payResultInfo.
          const paymentOrderNo =
            data.paymentOrderNo ||
            result.paymentOrderNo ||
            _.get(result, 'payResultInfo.paymentOrderNo')
          const hasPaymentMethod = !!_.get(result, 'payResultInfo.paymentMethod')
          if (!hasPaymentMethod && paymentOrderNo) {
            dispatch(
              callAPI({
                dispatch: dispatch,
                method: 'POST',
                body: {
                  orderToken: data.orderToken,
                  paymentOrderNo: `${paymentOrderNo}`,
                },
                errControl: true,
                hideProgress: true,
                endpoint: 'cashierii/pay/v1/unauth/query-result',
                requestAction: PAY_PAGE_RESULT.INIT_REQUEST,
                successAction: PAY_PAGE_RESULT.INIT_SUCCESS,
                success: function(res2) {
                  const pm = _.get(res2, 'payResultInfo.paymentMethod')
                  if (pm) {
                    dispatch({
                      type: PAY_PAGE_RESULT.INIT_SUCCESS,
                      payload: {
                        payResultInfo: {
                          ...(_.get(getState(), 'payPageResultState.payResultInfo') || {}),
                          ...(_.get(result, 'payResultInfo') || {}),
                          paymentMethod: pm,
                        },
                      },
                    })
                  }
                },
              })
            )
          }

          if (getState().router.location.pathname !== '/pay-page/result') {
            return false
          }
          if (result.payResult === 'P' && !result.payResultInfo) {
            setTimeout(() => {
              window.location.href = `/pay-page/main?ft=${data.orderToken}`
            }, 5000)
            return
          }
          if (result.payResult === 'P' && count > 0) {
            // 处理中的订单轮询5次，每次间隔2s
            setTimeout(() => {
              dispatch(init(data, --count))
            }, 2000)
          } else {
            setTimeout(() => {
              recordCountlyEvent({
                page_name: 'paypage_pay_result',
                biz_tags: {
                  order_token: data.orderToken,
                  payment_order_no:data.paymentOrderNo,
                  pay_result:result.payResult
                }
              })
              dispatch({
                type: PAY_PAGE_RESULT.QUERY_FINISH,
                payload: true,
              })
            }, 1000)
          }
        },
      })
    )
  }
}

export function fetchBanner() {
  return (dispatch, getState) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body:{
          itemKey:'PAY_PAGE_RESULT_BANNER',
          version:0
        },
        endpoint:  'cmsii/v1/app/configurationItem',
        requestAction: PAY_PAGE_RESULT.GET_BANNER_REQUEST,
        successAction: PAY_PAGE_RESULT.GET_BANNER_SUCCESS,
        success: function(result) {

        },
      })
    )
  }
}

export function downloadPDF(data, callback) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch,
        method: 'POST',
        body: data,
        endpoint:  'cashierii/pay/v1/unauth/pay-result-file',
        requestAction: PAY_PAGE_RESULT.DOWN_LOAD_REQUEST,
        successAction: PAY_PAGE_RESULT.DOWN_LOAD_SUCCESS,
        success(result) {
          typeof callback === 'function' && callback(null, result)
        },
        error() {
          typeof callback === 'function' && callback(new Error('error'))
        }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PAY_PAGE_RESULT.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [PAY_PAGE_RESULT.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [PAY_PAGE_RESULT.QUERY_FINISH]: (state, action) =>
    Object.assign({}, state, { queryFinish: action.payload }),
  [PAY_PAGE_RESULT.GET_BANNER_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [PAY_PAGE_RESULT.GET_BANNER_SUCCESS]: (state, action) =>
    Object.assign({}, state, { banner: action.payload.content }),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'payPageResult',
    reducerMap: {
      payPageResultState: reducer,
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)],
    // Actions to fire when this module is added/removed
    initialActions: [getThemeVariables(), getCountries()],
    // finalActions: []
  }
}
